/*
 reportFilterSelector

 This component creates the UI for a report filter selector.

 */

import kendo from '@progress/kendo-ui';
import $ from 'jquery';
import ko from 'knockout';
import _, { isNumber } from 'lodash';
import { authService } from '../login';

ko.components.register('report-filter-values-selector', {
    viewModel: reportFilterValuesSelector,
    template: {
        element: 'report-filter-values-selector-template'
    }
});


function reportFilterValuesSelector(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof reportFilterValuesSelector)
        return data;

    self.filter = data.filter;
    self.filterTitle = "";
    self.controlId = ko.observable("");
    self.listValueColumns = null;
    self.sourceGrid = {};
    self.destinationGrid = {};
    self.sourceGridSearch = ko.observable("");
    self.isEditable = ko.observable(data.filter.sourceType() === data.editorSourceType());

    var gridsCreated = false;

    self.addSelectedFilters = function () {

        //Get the selected grid rows
        var selectedGridRows = self.sourceGrid.select();

        //Process the rows
        _.forEach(selectedGridRows, function (row) {

            //Get the dataItem and it's value for the filter field
            var dataItem = self.sourceGrid.dataItem(row);

            var isNumValue = isNumber(dataItem["ListValue"]);
            var value = isNumValue ? dataItem["ListValue"] : dataItem["ListValue"]  || "";

            //Don't add the value if it's in there already
            var matchingValue = _.find(self.filter.listValues(), function (v) { return v === value; });
            if (typeof(matchingValue) != "undefined")
                return;

            //Add the value and the dataItem
            self.filter.listValues.push(value);
            self.destinationGrid.dataSource.add(dataItem);
        });
    }

    self.removeSelectedFilters = function () {
        //Get the selected grid rows
        var selectedGridRows = self.destinationGrid.select();

        var uidsToRemove = [];

        //Process the rows
        _.forEach(selectedGridRows, function (row) {

            //Get the dataItem and it's value for the filter field
            var dataItem = self.destinationGrid.dataItem(row);

            var isNumValue = isNumber(dataItem["ListValue"]);
            var value = isNumValue ? dataItem["ListValue"] : dataItem["ListValue"] || "";

            //Remove the value from our list
            var indx = _.indexOf(self.filter.listValues(), value);
            if (indx >= 0) {
                self.filter.listValues.splice(indx, 1);
            }

            //Store the uid of the grid row
            uidsToRemove.push($(row).data("uid"));
        });

        //Remove the selected grid rows
        _.forEach(uidsToRemove, function (uid) {
            self.destinationGrid.removeRow('tr[data-uid="' + uid + '"]');
        });
    }

    //Subscribe to updates of the columnId property
    self.filter.columnId.subscribeChanged(function (newValue, oldValue) {

        //Create the grids if we should show
        if (self.filter.showFilterSelector())
            createGrids();
    });

    //Subscribe to updates of the showFilterSelector property
    self.filter.showFilterSelector.subscribeChanged(function (newValue, oldValue) {

        //Create the grids if we should show
        if (newValue === true) {
            createGrids();
        }
    });

    self.filter.refreshValuesSelector = function () {
        createGrids();
    }

    self.sourceGridSearch.subscribeChanged(function (newValue, oldValue) {

        if (self.sourceGrid && self.sourceGrid.dataSource && self.sourceGrid.dataSource.transport) {

            var filter = {
                field: "ListValue",
                operator: "contains",
                value: newValue
            }

            self.sourceGrid.dataSource.filter(filter);
        }
    });

    self.clearSourceGridSearch = function () {
        self.sourceGridSearch("");
    }

    var createGrids = function () {

        //Get the DOM elements
        var $element = $("#" + self.controlId());

        //Find the search box and append it to the root of the element.
        //This will prevent the grid from overwriting it.
        var $sourceGridSearchBox = $element.find(".source-grid-search");
        $sourceGridSearchBox.find("input").val("");
        $element.append($sourceGridSearchBox);

        var $sourceGridElement = $element.find(".source-grid");
        var $destinationGridElement = $element.find(".destination-grid");
        $sourceGridElement.empty();
        $destinationGridElement.empty();

        //Get the listValueColumn
        var listValueColumn = _.find(self.listValueColumns, function (col) { return col.columnId === self.filter.columnId(); });

        if (_.isNullOrUndefined(listValueColumn) || _.isNullOrUndefined(self.filter.column))
            return;

        //Get the filter title
        self.filterTitle = ko.isObservable(self.filter.column.title) ? self.filter.column.title() : self.filter.column.title;

        //TRAC-79 - if this is a date column then we need to format the display so it will sort correctly
        var displayFormat = ko.isObservable(self.filter.column.format) ? self.filter.column.format() : self.filter.column.format;
        var isDateFilter = displayFormat?.toLowerCase() === "date";
        var filterColumnTemplate = isDateFilter ? "#= kendo.toString(kendo.parseDate(ListValue, 'yyyy-MM-dd'), 'MM/dd/yyyy') #" : null;

        var sourceDataSource = new kendo.data.DataSource({
            type: "odata",
            serverPaging: true,
            serverSorting: true,
            serverFiltering: true,
            pageSize: 1000,
            transport: {
                read: {
                    async: true,
                    url: `${API_URL}/listofvalues/getlistofvalues?columnid=` + self.filter.columnId(),
                    dataType: "json",
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
                    }
                }
            },
            schema: {
                data: "",
                total: function (data) {
                    return data.length;
                }
            },
            sort: { field: "ListValue", dir: isDateFilter ? "desc" : "asc" }
        });

        //Add all the listValues into the selectedFilters array
        //with the correct fieldName so binding to the dest grid works.
        var listValueDataItems = [];
        _.forEach(self.filter.listValues(), function (val) {

            //Add a dataItem to the list
            var dataItem = {};
            dataItem["ListValue"] = ko.isObservable(val) ? val() : val;
            listValueDataItems.push(dataItem);
        });

        var destinationDataSource = new kendo.data.DataSource({
            data: listValueDataItems,
            pageSize: 1000,
            sort: { field: "ListValue", dir: isDateFilter ? "desc" : "asc" }
        });

        self.sourceGrid = $sourceGridElement.kendoGrid({
            dataSource: sourceDataSource,
            width: 100,
            height: 300,
            selectable: "multiple",
            filterable: {
                mode: "row"
            },
            scrollable: {
                virtual: true
            },
            sortable: true,
            columns: [{
                field: "ListValue",
                title: self.filterTitle,
                template: filterColumnTemplate,
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            }]
        }).data("kendoGrid");

        self.destinationGrid = $destinationGridElement.kendoGrid({
            dataSource: destinationDataSource,
            height: 300,
            selectable: "multiple",
            sortable: true,
            columns: [
                { field: "ListValue", title: "Filter Values", template: filterColumnTemplate },
            ]
        }).data("kendoGrid");

        //Move our search box to the grid filter row
        var $sourceGridFilterRow = $sourceGridElement.find(".k-filter-row > th");
        $sourceGridFilterRow.empty().append($sourceGridSearchBox);

        //Make sure the grids have room to show the loading spinner
        $sourceGridElement.find('.k-grid-content').css('height', '224px');
        $destinationGridElement.find('.k-grid-content').css('height', '270px');
    }

    var init = function () {

        //Create an id for this control
        self.controlId("report-filter-selector-" + _.random(1000000));

        //Get the listValueColumn that matches the filter column
        self.listValueColumns = ko.isObservable(data.listValueColumns) ? data.listValueColumns() : data.listValueColumns;
    }

    //Init the UI
    init();
}